export const fields = [
  {
    key: 'Nro',
    label: 'Nro',
    width: 10,
    tdClass: 'nro-field'
  },
  {
    key: 'rakennekerros',
    label: 'Rakennekerros',
    width: 110
  },
  {
    key: 't_mm',
    label: 'Paksuus [mm]',
    width: 30
  },
  {
    key: 'paloon_reagointi',
    label: 'Paloon reagointi',
    width: 30,
    formatter: (value, key, item) => {
      if (item.paloon_reagointi) {
        if (item.paloon_reagointi.length > 1) {
          return (
            item.paloon_reagointi[0].name +
            '<br />' +
            item.paloon_reagointi[1].name
          )
        }
        if (item.paloon_reagointi.length > 0) {
          return item.paloon_reagointi[0].name
        }
      }
      return ''
    }
  }
]
export const paloluokat = [
  {
    index: '3',
    class: 'P1',
    value: 'R 60'
  },
  {
    index: '42',
    class: 'P2',
    value: 'R 60'
  },
  {
    index: '4',
    class: 'P2',
    value: 'R 30'
  },
  {
    index: '5',
    class: 'P3',
    value: 'R 0'
  }
]



// WEBPACK FOOTER //
// ./src/data/constants.js